import React from 'react'
import PropTypes, { array, func, object } from 'prop-types'
import { Tooltip } from '@mui/material'

const ToolTip = ({
  onClose,
  leaveDelay = 3000,
  open,
  placement = 'top',
  isArrow = true,
  contentToolTip,
  children,
}) => {
  return (
    <Tooltip
      arrow={isArrow}
      placement={placement}
      leaveDelay={leaveDelay}
      open={open}
      onClose={onClose}
      componentsProps={{
        tooltip: {
          style: styles.tooltip,
        },
        arrow: {
          style: styles.arrow,
        },
      }}
      title={contentToolTip}>
      {children}
    </Tooltip>
  )
}

export default React.memo(ToolTip)

ToolTip.propTypes = {
  contentToolTip: PropTypes.oneOfType([array, func, object]),
  children: PropTypes.oneOfType([array, func, object]),
  onClose: PropTypes.func,
  leaveDelay: PropTypes.number,
  open: PropTypes.bool,
  placement: PropTypes.string,
  isArrow: PropTypes.bool,
}

const styles = {
  tooltip: {
    backgroundColor: 'white',
    boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
    marginBottom: '10px',
    color: 'black',
    padding: 0,
  },
  arrow: {
    color: 'white',
  },
}
